import { z } from 'zod';
import { formatPhoneInput } from '../external-link-send/utils/phone';

// ── Step A — 고객 정보 ────────────────────────────────────────────────────────
export const stepASchema = z.object({
  customerName: z
    .string()
    .min(1, '고객명을 입력해 주세요.')
    .max(100, '고객명은 100자 이하입니다.'),
  customerMobile: z
    .string()
    .min(1, '전화번호를 입력해 주세요.')
    .regex(/^01[0-9]-\d{3,4}-\d{4}$/, '010-0000-0000 형식으로 입력해 주세요.'),
});
export type StepAFormValues = z.infer<typeof stepASchema>;

// ── Step B — 현장 정보 (기획서 E-4 기준) ─────────────────────────────────────
export const stepBSchema = z.object({
  siteAddress: z.string().min(1, '주소를 입력해 주세요.'),
  addressDtl: z.string().optional(),
  bldgName: z.string().optional(),
  /** 에이전트별 requiredSteps에 'C' 포함 시 필수. 폼 스키마는 optional 처리 후 submit 시 추가 검증. */
  sitePyeong: z.string().optional(),
  addressDong: z.string().optional(),
  addressHo: z.string().optional(),
  siteName: z.string().min(1, '현장명을 입력해주세요.'),
  siteMemo: z.string().optional(),
});
export type StepBFormValues = z.infer<typeof stepBSchema>;

// ── Step C — 도면 정보 ────────────────────────────────────────────────────────
export const stepCSchema = z.object({
  /** 단지 마스터 미매핑 상태에서만 수정 가능 */
  sitePyeong: z.string().optional(),
});
export type StepCFormValues = z.infer<typeof stepCSchema>;

export { formatPhoneInput };
